export default {"src":"/_next/static/media/share_icon.9994a96a.svg","height":21,"width":21,"blurWidth":0,"blurHeight":0};